import logo from "./imagens/lgAman.png";
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './Paginas/Home';
import Header from './Paginas/Header';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Routes>
        <Route path='/' element={<Home />} />
      </Routes>
    </div>
  );
}

export default App;
